import React from "react";

const MenuSectionDecorations = () => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {/* Indian food items */}
      <div
        className="absolute top-10 left-1/4 animate-float opacity-40"
        style={{ animationDelay: "0s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-12">🍛</div>
      </div>

      <div
        className="absolute top-32 right-1/4 animate-float opacity-45"
        style={{ animationDelay: "1.5s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-12">🥘</div>
      </div>

      {/* Breakfast items */}
      <div
        className="absolute top-1/4 left-16 animate-float opacity-40"
        style={{ animationDelay: "2s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-6">🥞</div>
      </div>

      <div
        className="absolute top-1/3 right-20 animate-float opacity-45"
        style={{ animationDelay: "0.8s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-8">🥐</div>
      </div>

      {/* Snacks and sides */}
      <div
        className="absolute top-1/2 left-10 animate-float opacity-40"
        style={{ animationDelay: "1.2s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-15">🍟</div>
      </div>

      <div
        className="absolute top-1/2 right-12 animate-float opacity-45"
        style={{ animationDelay: "2.2s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-10">🌯</div>
      </div>

      {/* Drinks */}
      <div
        className="absolute bottom-1/3 left-1/4 animate-float opacity-40"
        style={{ animationDelay: "0.5s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-8">🥤</div>
      </div>

      <div
        className="absolute bottom-1/4 right-1/3 animate-float opacity-45"
        style={{ animationDelay: "1.8s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-12">☕</div>
      </div>

      {/* Desserts */}
      <div
        className="absolute bottom-20 left-1/3 animate-float opacity-40"
        style={{ animationDelay: "1s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-10">🍰</div>
      </div>

      <div
        className="absolute bottom-32 right-1/4 animate-float opacity-45"
        style={{ animationDelay: "2.5s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-15">🧁</div>
      </div>

      {/* More variety */}
      <div
        className="absolute top-2/3 left-20 animate-float opacity-40"
        style={{ animationDelay: "1.7s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-12">🍝</div>
      </div>

      <div
        className="absolute bottom-1/2 right-16 animate-float opacity-45"
        style={{ animationDelay: "0.3s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-8">🥗</div>
      </div>

      {/* Leaf decorations for menu section */}
      {/* Top left cluster */}
      <div
        className="absolute top-16 left-12 animate-leaf opacity-50"
        style={{ animationDelay: "0.2s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-25">🍃</div>
      </div>
      <div
        className="absolute top-20 left-16 animate-leaf opacity-55"
        style={{ animationDelay: "0.4s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-20">🍃</div>
      </div>
      <div
        className="absolute top-24 left-20 animate-leaf opacity-60"
        style={{ animationDelay: "0.6s" }}
      >
        <div className="text-3xl md:text-4xl transform rotate-15">🍃</div>
      </div>

      {/* Top right cluster */}
      <div
        className="absolute top-24 right-16 animate-leaf opacity-50"
        style={{ animationDelay: "1.3s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-25">🍃</div>
      </div>
      <div
        className="absolute top-28 right-12 animate-leaf opacity-55"
        style={{ animationDelay: "1.5s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-20">🍃</div>
      </div>
      <div
        className="absolute top-32 right-8 animate-leaf opacity-60"
        style={{ animationDelay: "1.7s" }}
      >
        <div className="text-3xl md:text-4xl transform -rotate-15">🍃</div>
      </div>

      {/* Middle left cluster */}
      <div
        className="absolute top-1/2 left-8 animate-leaf opacity-50"
        style={{ animationDelay: "2.3s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-30">🍃</div>
      </div>
      <div
        className="absolute top-1/2 left-12 animate-leaf opacity-55"
        style={{ animationDelay: "2.5s" }}
      >
        <div
          className="text-2xl md:text-3xl transform rotate-25"
          style={{ marginTop: "1rem" }}
        >
          🍃
        </div>
      </div>
      <div
        className="absolute top-1/2 left-16 animate-leaf opacity-60"
        style={{ animationDelay: "2.7s" }}
      >
        <div
          className="text-3xl md:text-4xl transform rotate-20"
          style={{ marginTop: "2rem" }}
        >
          🍃
        </div>
      </div>

      {/* Middle right cluster */}
      <div
        className="absolute top-1/2 right-8 animate-leaf opacity-50"
        style={{ animationDelay: "0.8s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-30">🍃</div>
      </div>
      <div
        className="absolute top-1/2 right-12 animate-leaf opacity-55"
        style={{ animationDelay: "1.0s" }}
      >
        <div
          className="text-2xl md:text-3xl transform -rotate-25"
          style={{ marginTop: "1rem" }}
        >
          🍃
        </div>
      </div>
      <div
        className="absolute top-1/2 right-16 animate-leaf opacity-60"
        style={{ animationDelay: "1.2s" }}
      >
        <div
          className="text-3xl md:text-4xl transform -rotate-20"
          style={{ marginTop: "2rem" }}
        >
          🍃
        </div>
      </div>

      {/* Bottom left cluster */}
      <div
        className="absolute bottom-16 left-20 animate-leaf opacity-50"
        style={{ animationDelay: "1.9s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-35">🍃</div>
      </div>
      <div
        className="absolute bottom-20 left-24 animate-leaf opacity-55"
        style={{ animationDelay: "2.1s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-30">🍃</div>
      </div>
      <div
        className="absolute bottom-24 left-28 animate-leaf opacity-60"
        style={{ animationDelay: "2.3s" }}
      >
        <div className="text-3xl md:text-4xl transform rotate-25">🍃</div>
      </div>

      {/* Bottom right cluster */}
      <div
        className="absolute bottom-24 right-24 animate-leaf opacity-50"
        style={{ animationDelay: "0.6s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-35">🍃</div>
      </div>
      <div
        className="absolute bottom-28 right-20 animate-leaf opacity-55"
        style={{ animationDelay: "0.8s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-30">🍃</div>
      </div>
      <div
        className="absolute bottom-32 right-16 animate-leaf opacity-60"
        style={{ animationDelay: "1.0s" }}
      >
        <div className="text-3xl md:text-4xl transform -rotate-25">🍃</div>
      </div>
    </div>
  );
};

export default MenuSectionDecorations;
